import React, { useCallback, useState } from "react";
import { Accordion } from "reactstrap";
import { ProjectDownloadAccordionItem } from "./ProjectDownloadAccordionItem";
import { ProjectDownloadSortDropdown } from "./ProjectDownloadSortDropdown";
import { ProjectDownloadAccordionItemSublist } from "./ProjectDownloadAccordionItemSublist";
import type { CheckboxItem } from "interfaces/product/product.types";
import type { Dispatch, SetStateAction } from "react";

type Props = {
  blockTitle: string;
  itemsData: CheckboxItem[];
  setItemsData: Dispatch<SetStateAction<CheckboxItem[]>>;
  showProducts: boolean;
  expandedAccordionIds: string[];
  setExpandedAccordionIds: Dispatch<SetStateAction<string[]>>;
  seriesId?: string;
};

export const ModalCheckboxesBlock = ({
  blockTitle,
  itemsData,
  setItemsData,
  showProducts,
  expandedAccordionIds,
  setExpandedAccordionIds,
}: Props) => {
  const [sublistItemOpen, setSublistItemOpen] = useState<string>("");

  const toggle = useCallback(
    (id: string): void => {
      setExpandedAccordionIds((prevOpen) =>
        prevOpen.includes(id)
          ? prevOpen.filter((itemId) => itemId !== id)
          : [...prevOpen, id],
      );
    },
    [setExpandedAccordionIds],
  );

  const toggleSublist = useCallback((id: string): void => {
    setSublistItemOpen((prevValue) => (prevValue === id ? "" : id));
  }, []);

  return (
    <div className="flex-xs-column d-flex gap-2">
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="text-uppercase mb-0 font20">{blockTitle}</h3>
        <ProjectDownloadSortDropdown showProducts={showProducts} />
      </div>
      <Accordion open={expandedAccordionIds} toggle={toggle}>
        {itemsData &&
          itemsData.map((item, index) => (
            <ProjectDownloadAccordionItem
              expandedAccordionIds={expandedAccordionIds}
              title={item.title}
              key={item.title + index}
              checked={item.checked}
              setItemsData={setItemsData}
              toggle={toggle}
              hasContent={item.checkboxContent.length > 0}
              itemsData={itemsData}
              id={item.id}
            >
              {!item.skipContentRender && (
                <ProjectDownloadAccordionItemSublist
                  item={item}
                  toggleSublist={toggleSublist}
                  sublistItemOpen={sublistItemOpen}
                  setItemsData={setItemsData}
                  itemsData={itemsData}
                />
              )}
            </ProjectDownloadAccordionItem>
          ))}
      </Accordion>
    </div>
  );
};
